<template>
   <div class="layout">
    <!-- 上面导航 -->
     <div class="sidebat">
        <Sidebar ></Sidebar>


     </div>
     <!-- 中间内容 -->
      <div class="content" :class="{small:isCollapse}">
        <Content @changeShow="changeShow" :isCollapse="isCollapse"></Content>
      </div>

      <!-- 网页底部 -->
       <Footer></Footer>
   </div>
  </template>
  
  <script>
import Sidebar from "./sidebar/Index.vue"
import Content from "./content/Index.vue"
import Footer from "./footer/Index.vue"


  export default {
    name: 'layoutIndex',  // 修改为多词的组件名称
    components: {
    Sidebar,
    Content,
    Footer,
  },
  data() {
  return {
    isCollapse: false, // 根据需要设置初始值
  };
},
methods:{
  changeShow() {
    this.isCollapse = !this.isCollapse;
  }
}
  }
  </script>
  
  <style>


  .small{
    padding-left: 64px;
    
  }
  </style>